import React from 'react'
import { convertToHTMl } from '../../../../utils/markDown'

class remarkTextRender extends React.PureComponent {
	render() {
		const { remarkText } = this.props
      
		return (
			<>
            <p>หมายเหตุ</p>
				<div style={{ marginLeft:"-16px" }}>
               {
                  remarkText ?
                     <div  dangerouslySetInnerHTML={{ __html: convertToHTMl(remarkText ? remarkText : "<h1></h1>") }} />
                  :
                  ''
               }
            </div>
			</>
		)
	}
}

export default remarkTextRender
